const Error = () => {
  return <div>Some error occurred</div>
}

export default Error
